"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != (0, _typeof2.default)(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } /** When your routing table is too long, you can split it into small modules **/
var schoolRouter = {
  path: '/schoolTest',
  component: _layout.default,
  redirect: '/school',
  children: [{
    path: 'school',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/school/index.vue'));
      });
    },
    // Parent router-view
    name: 'school',
    meta: {
      title: '学校管理',
      icon: 'dashboard'
    }
  }, {
    path: 'school-add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/school/schoolAdd.vue'));
      });
    },
    name: 'school-add',
    hidden: true,
    meta: {
      title: '新增学校'
    }
  }, {
    path: 'school-view',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/school/schoolView.vue'));
      });
    },
    name: 'school-view',
    hidden: true,
    meta: {
      title: '查看学校管理员'
    }
  }, {
    path: 'school-view-edit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/school/schoolViewEdit.vue'));
      });
    },
    name: 'school-view-edit',
    hidden: true,
    meta: {
      title: '编辑管理员信息'
    }
  }, {
    path: 'school-edit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/school/schoolEdit.vue'));
      });
    },
    name: 'school-edit',
    hidden: true,
    meta: {
      title: '编辑学校'
    }
  }]
};
var _default = exports.default = schoolRouter;